import { CVLibrarySearch } from 'wisestep-api';

import BasicSearchForm from '../../types/IBasicSearchForm';
import ICVLibraryAdvanceSearch from '../types/ICVLibraryAdvanceSearch';
export default function (values: BasicSearchForm & ICVLibraryAdvanceSearch) {
  const query: CVLibrarySearch = {
    accountId: values.accountId,
    age: '',
    salary: values.salary && values.salary,
    industry: values.industry && values.industry,
    language: values.language && values.language,
    distance: values.distance ? '' + values.distance : '',
    distanceUnit: 'miles',
    stemPhrases: values.stemPhrases && values.stemPhrases,
    searchJobTitleOnly: values.searchJobTitleOnly && values.searchJobTitleOnly,
    searchNameOnly: values.searchNameOnly && values.searchNameOnly,
    relocation: values.relocation && values.relocation,
    time: values.lastActive && values.lastActive,
    tempPerm: values.tempPerm && values.tempPerm,
    minMatch: values.minMatch && values.minMatch,
    perpage: values.pageSize,
    order: values.sort,
    offset: values.page * values.pageSize,
    useGeo: 0,
    q: values.query ? values.query : '',
  };
  if (values.locations) {
    query.area = values.locations.map((location) => location.id).join(',');
  }
  return query;
}
